import { forwardRef, useContext } from 'react'
import { RadioContext } from 'components/RadioGroup/RadioContext'
import { RadioGroupState } from '@react-stately/radio'
import { useObjectRef } from 'utils/useObjectRef'
import { Chip } from 'components/Chip/Chip'
import { ChipProps } from 'components/Chip/Types'

export const ChipRadioButton = forwardRef<HTMLButtonElement, ChipProps & { value: string }>(
  ({ children, ...props }, fRef) => {
    const state = useContext(RadioContext) as RadioGroupState
    const ref = useObjectRef(fRef)
    const isSelected = state.selectedValue === props.value

    return (
      <Chip
        ref={ref}
        deletable={false}
        {...props}
        role="radio"
        aria-checked={isSelected}
        onChange={() => state.setSelectedValue(props.value)}
        isSelected={isSelected}
        onFocus={() => state.setSelectedValue(props.value)}
      >
        {children}
      </Chip>
    )
  },
)
